module.exports = __webpack_public_path__ + "img/digitalticket_ticket.ae8e87cc.svg";